<div class="thread-list" (click)="$event.stopPropagation()">

  @if (chatSession.isLoadingThreads()) {
    <div class="d-flex justify-content-center align-items-center py-3">
      <mat-spinner diameter="24" />
    </div>
  } @else if (chatSession.threads().length === 0) {
    <p class="mat-font-body-sm text-secondary text-center py-2 mb-0">No conversations yet</p>
  } @else {
    @for (thread of chatSession.threads(); track thread.threadId) {
      <div
        class="thread-item d-flex align-items-center gap-1 px-2 py-1 rounded"
        [class.thread-item--active]="thread.threadId === chatSession.threadId()"
        (click)="onSelect(thread.threadId)"
        role="button"
        [attr.aria-current]="thread.threadId === chatSession.threadId() ? 'true' : null"
      >
        <div class="d-flex flex-column flex-fill overflow-hidden">
          <span class="mat-font-body-sm text-truncate">{{ thread.name }}</span>
          <span class="mat-font-label-sm text-secondary">{{ isValidDate(thread.createdAt) ? (thread.createdAt | date: 'MMM d, y, h:mm a') : '' }}</span>
        </div>
        <button
          matIconButton
          class="flex-shrink-0 thread-item__delete"
          [matTooltip]="'Delete'"
          aria-label="Delete conversation"
          (click)="onDeleteClick(thread.threadId, thread.name, $event)"
        >
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    }
  }

</div>
